import { Alert, Modal, Typography } from "antd";

const { Paragraph, Text } = Typography;

export default function TokenModal({ token, onFechar }) {
  return (
    <Modal
      open={Boolean(token)}
      title="Token do gateway"
      closable={false}
      maskClosable={false}
      okText="Já copiei"
      cancelButtonProps={{ style: { display: "none" } }}
      onOk={onFechar}>
      <Alert
        type="warning"
        showIcon
        message="Copie agora. Este token não aparece de novo."
        style={{ marginBottom: 12 }}
      />
      <Paragraph copyable code style={{ wordBreak: "break-all" }}>
        {token}
      </Paragraph>
      <Text type="secondary">
        Cole no gateway da loja: na janela, em Configuração, ou com{" "}
        <Text code>ouran-gateway token definir</Text>.
      </Text>
    </Modal>
  );
}
